"use client";

import { usePathname } from "next/navigation";
import { hasEsPrefix, localeHref } from "./es-path";

// PASTE #233 path-based ES: client-side locale-aware links. Derives the
// locale from the CURRENT URL (whether it starts with /es) rather than a
// prop, so client components keep navigation Spanish on /es pages with
// zero prop-threading. Safe for the signed-in portal: its routes are
// bare (never /es), so links stay unprefixed and behavior is unchanged.
export function useLocaleHref(): (href: string) => string {
  const pathname = usePathname();
  const locale = hasEsPrefix(pathname ?? "") ? "es" : "en";
  return (href: string) => localeHref(href, locale);
}
